module.exports = __webpack_public_path__ + "img/footer-4.e3dcbd75.png";